import { createFileRoute } from "@tanstack/react-router";
import SignInForm from "@/ui/components/auth/sign-in";

/**
 * The sign-in form. Every unauthenticated bounce lands here — the route guards
 * send a session-less visitor to `/sign-in`, as do the sign-out handlers and
 * the links in already-delivered emails.
 *
 * `/` is the app home (the workspace on the customer app, the dashboard on the
 * admin one), not a second copy of this form: routing here back to `/` would
 * only be bounced to `/sign-in` again by the guard that sent us.
 *
 * The Suspense boundary the Next.js page wrapped this in existed because the
 * form reads `useSearchParams()`, which suspended during a server render.
 * There is no server render here, so it is no longer needed.
 */
export const Route = createFileRoute("/_auth/sign-in")({
  component: SignInForm,
});
